import React from "react";
import { FaFacebookF, FaLinkedin, FaWhatsapp, FaGithub } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-[#211033] text-gray-100 py-10 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Left Section */}
        <div>
          <h1 className="text-2xl font-bold">FAHIM FERDOUS</h1>
          <p className="mt-3 text-sm text-gray-300">
            Convert your thoughts into reality.
          </p>
        </div>

        {/* Center Section */}
        <div>
          <h3 className="uppercase font-semibold text-sm mb-2">
            Latest Tech updates
          </h3>
          <form className="flex flex-col sm:flex-row items-center gap-3 mt-3">
            <input
              type="email"
              placeholder="Your e-mail"
              className="w-full sm:w-auto flex-1 px-4 py-2 border border-gray-300 rounded focus:outline-none text-sm"
            />
            <button
              type="submit"
              className="bg-pink-700 text-white text-sm px-5 py-2 rounded hover:bg-pink-800 transition"
            >
              Subscribe
            </button>
          </form>
        </div>

        {/* Right Section */}
        <div className="flex justify-center gap-5">
          <div>
            <h4 className="text-sm font-semibold mb-1">Follow Me</h4>
            <div className="flex gap-4 text-gray-500">
              <a href="https://fb.com/fahimferdous.shibly" target="_blank" rel="noopener noreferrer">
                <FaFacebookF className="hover:text-blue-600" />
              </a>
              <a href="https://linkedin.com/in/fahim-ferdous" target="_blank" rel="noopener noreferrer">
                <FaLinkedin className="hover:text-blue-700" />
              </a>
              <a href="https://wa.me/8801744353576" target="_blank" rel="noopener noreferrer">
                <FaWhatsapp className="hover:text-green-600" />
              </a>
              <a href="https://github.com/F-ferdous" target="_blank" rel="noopener noreferrer">
                <FaGithub className="hover:text-gray-200" />
              </a>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold mb-1">Call Me</h4>
            <p className="text-base font-medium text-gray-500">
              880 1744 353576
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
